import { matchSorter, rankings } from 'match-sorter';

import type { GetApplyQuickFilterFn } from '@mui/x-data-grid';

import { removeDiacritics } from '@e-socna/utils';

export const getMatchSorterQuickFilterFn: GetApplyQuickFilterFn = (
  value: string,
) => {
  if (!value) {
    return null;
  }

  // eslint-disable-next-line max-params -- signature forced by MUI's GetApplyQuickFilterFn
  return (_cellValue, row, column, apiRef) => {
    const columnValue = apiRef.current.getRowFormattedValue<unknown>(
      row,
      column,
    );

    if (columnValue === undefined || columnValue === null) {
      return false;
    }

    const columnValueAsString =
      typeof columnValue === 'string' ||
      typeof columnValue === 'number' ||
      typeof columnValue === 'boolean' ||
      typeof columnValue === 'bigint'
        ? String(columnValue)
        : JSON.stringify(columnValue);

    return (
      matchSorter([removeDiacritics(columnValueAsString)], value, {
        threshold: rankings.CONTAINS,
      }).length > 0
    );
  };
};
